import { iconsSet } from "../../../../assets/icons/icons";

export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_growinvestimentos.png",
      alt: "Estratégias GRoW Investimentos",
    },
    title: "Opere inteligente, opere com a GRoW! ",

    // String ou array de strings
    text: "GRoW – Robôs de investimento desenvolvidos por traders experientes, projetados para impulsionar seu crescimento de capital e gerar resultados consistentes!",
    testimonial: {
      text: "Deixe a emoção de lado e use a estatística a seu favor. Os sets da GRoW, você poderá alcançar a consistência que todo trader busca! ",
      author: {
        name: "Gustavo Ruffato – GRoW Investimentos.",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/mauro_quantic_profile.png",
      },
    },
  },

  strategies: {
    title: "Portfólios exclusivos GRoW",
    heading: "Conheça os robôs do GRoW e mude sua forma de operar na B3!",
    subtitle:
      "Os robôs GRoW foram desenvolvidos com base em anos de experiência em trading, combinando estratégias avançadas de análise técnica e inteligência artificial, dando uma maior precisão aos seus trades. ",
  },

  cta: {
    title: "CONCILIE SUAS OPERAÇÕES COM SUA VIDA PESSOAL E PROFISSIONAL.",
    subtitle: "Os robôs GRoW oferecem essa liberdade! ",
    buttonText: "Eu Quero!",
  },

  about: {
    title: "Sobre o Desenvolvedor",
    subtitle: "A GRoW",
    col1: [
      "A GRoW Investimentos nasceu da necessidade de oferecer ferramentas confiáveis para os entusiastas do mercado financeiro. Com mais de 13 anos de experiência no mercado de renda variável, Gustavo Ruffato fundou a GRoW com o objetivo de facilitar a jornada dos investidores, proporcionando soluções que tornam o caminho no mercado mais seguro e eficiente. ",
    ],
  },

  stats: {
    title: "Nossas Conquistas ",
    subtitle: "Histórias se constroem com resultados ",
    data: [
      {
        value: "+10",
        description: "Anos de experiencia",
      },
      {
        value: "+1mil",
        description: "Estratégias criadas ",
      },
      {
        value: "+200%",
        description: "Lucro no período de um ano",
      },
    ],
  },

  features: {
    // type: 2,
    title: "Por que utilizar os robôs da GRoW Investimentos?",
    subtitle: "Veja quais as principais vantagens dos robôs da GRoW Investimentos.",
    data: [
      {
        icon: iconsSet.favorite,
        title: "Eliminação da Emoção",
        description:
          "Os robôs de investimento seguem estratégias pré-definidas e não são influenciados por emoções, como medo ou ganância, que podem afetar decisões humanas.",
      },
      {
        icon: iconsSet.analytics,
        title: "Análise Baseada em Dados",
        description:
          "Robôs utilizam análises quantitativas e modelos matemáticos para tomar decisões informadas, eliminando o risco de erros causados por suposições ou falta de informação.",
      },
      {
        icon: iconsSet.play_circle,
        title: "100% no automático",
        description:
          "Ao contrário dos traders humanos, os robôs não precisam de descanso e estão sempre prontos para operar, aproveitando todas as oportunidades.",
      },
      {
        icon: iconsSet.chart,
        title: "Estratégias Consistentes",
        description:
          "Com base em dados e algoritmos, os robôs mantêm estratégias consistentes, ajudando a alcançar resultados de longo prazo sem desviar do plano.",
      },
      {
        icon: iconsSet.candlestick,
        title: "Melhoria no Timing de Mercado",
        description:
          "Os robôs de investimento são capazes de analisar padrões de mercado e identificar o melhor momento para entrar ou sair de uma operação, otimizando o timing e aumentando as chances de lucro.",
      },
      {
        icon: iconsSet.money,
        title: "Liberdade Financeira",
        description:
          "Para você que deseja atingir sua liberdade financeira com o mercado de capitais, os robôs de investimento permitem trabalhar de qualquer lugar e a qualquer hora, proporcionando flexibilidade e independência na sua jornada financeira.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Sou trader há mais de 15 anos e, desde o início da minha jornada com a GRoW Investimentos, utilizo os robôs de investimento da empresa. Os resultados têm sido consistentemente positivos, e o atendimento sempre se destacou pela excelência. Na minha experiência, são os melhores robôs do mercado.",
      author: "Jacques Safra",
      job: "Bancário",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/flavio-rezende.png",
    },
    {
      text: "Estou usando os robôs da  GRoW a alguns meses e estou satisfeito com o retorno, a segurança e a tranquilidade nas operações. Tentei operar no mercado de mini dólar e mini índice por vários anos sem resultados satisfatórios.",
      author: "Igor Gonçalves",
      job: "Engenheiro Químico",
      // image_url:
      //   "https://ontick-img.s3.sa-east-1.amazonaws.com/david-souza.png",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça nossos planos.",
  },
};
